// rc128 — Página de UNA sección de Ajustes (/ajustes/:section): encabezado
// con icono, descripción y "Volver a Ajustes", y la sección a todo lo ancho.
import { useEffect } from "react";
import { Link, Navigate, useLocation, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { seccionPorSlug } from "./ajustesCatalog";
import { useAuthStore } from "@/lib/auth";

export function AjustesSectionPage() {
  const { section } = useParams<{ section: string }>();
  const { hash } = useLocation();
  const s = seccionPorSlug(section);
  const hasPermission = useAuthStore((st) => st.hasPermission);
  const permitida = !!s && (!s.perm || hasPermission(s.perm));

  // Anclas dentro de la sección (p.ej. #auto-facturacion) — scroll al montar
  useEffect(() => {
    if (!hash || !s) return;
    const id = hash.replace(/^#/, "");
    const t = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
    return () => clearTimeout(t);
  }, [hash, s]);

  if (!s || !permitida) return <Navigate to="/ajustes" replace />;
  const Icon = s.icon;
  const Section = s.component;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Link
          to="/ajustes"
          className="inline-flex w-fit items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
        >
          <ChevronLeft size={14} />
          Ajustes
        </Link>
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
            <Icon size={20} />
          </div>
          <div className="min-w-0">
            <h2 className="text-lg font-semibold leading-tight">{s.titulo}</h2>
            <p className="text-xs text-muted-foreground">{s.descripcion}</p>
          </div>
        </div>
      </div>
      <Section />
    </div>
  );
}
